var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 60,
    viewBox: "0 0 47 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.213341 42.0411L44.4595 14.1682L39.881 11.2822L4.61902 33.7101L4.6498 28.842L36.1419 8.9254L31.4868 5.99132L4.53113 23.1021L4.59418 18.3654L27.7477 3.63448L23.0165 0.652344L0.0833435 14.9667L0.213341 42.0411Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3088 59.348L18.8812 56.3734L41.9569 41.7782V37.037L14.964 53.9565L2.0211 45.5897L46.5549 17.4218V23.0925L10.9621 45.5897L14.964 48.1926L46.5549 28.1125V44.753L23.3088 59.348Z",
    fill: "#026C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logo-blue.17f1af7b8cc32a08d0308485ae0542b4.svg";
export { ForwardRef as ReactComponent };